import AnchorButton from './AnchorButton';

export default AnchorButton;
